// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"styles_loginForm__d93qL","border":"styles_border__18bZU"};